import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { CourseCategoryManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/categories")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <CourseCategoryManagement />
    </RouteGuard>
  ),
});
